import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const BAR_COLOR = '#e8613c';
const Baseline = styled.div.withConfig({
  displayName: "VoiceInputWaveform__Baseline"
})(["flex:1;min-width:0;height:28px;background-image:repeating-linear-gradient( to right,", " 0 2px,transparent 2px 4px );background-size:100% 3px;background-repeat:no-repeat;background-position:center;"], BAR_COLOR);
const VoiceInputWaveform = () => /*#__PURE__*/_jsx(Baseline, {
  "aria-hidden": "true"
});
VoiceInputWaveform.displayName = 'VoiceInputWaveform';
export default VoiceInputWaveform;